import AppBottomBar from './AppBottomBar'

export default AppBottomBar
